import nr from "./navigationRoutes";

const PATHS: string[] = [
  nr.LOGIN,
  nr.EDIT_PROPERTY,
  nr.EDIT_COMPARISON_PROPERTY,
  nr.CREATE_PROPERTY,
  nr.CREATE_REHAB_ESTIMATOR,
  nr.MAX_BID_CALCULATION,
  nr.MAX_BID_CALCULATION_TABLE,
  nr.PROPERTY_MASTER,
  nr.COMPARISON_PROPERTY_MASTER,
  nr.CREATE_COMPARISON_PROPERTY,
  nr.REHAB_ESTIMATOR,
  nr.COMPARISON_CALCULATION,
  nr.REPORTS,
  nr.MY_PROPERTY,
  nr.DASHBOARD,
  nr.EDIT_MAX_BID_CALCULATION,
  nr.EDIT_REHAB_ESTIMATOR,
  nr.EDIT_MY_PROPERTY,
  nr.IMPORT_PROPERTY,
  nr.IMPORTANT_WEBSITE,
];

/**
 * Used for axios behavior (e.g. relaxed 401 on property portal).
 * Includes legacy URLs that still contain /property-portal/.
 */
export function isPropertyPortalPathname(pathname: string): boolean {
  if (pathname.includes("/property-portal")) {
    return true;
  }
  const path = pathname.replace(/\/$/, "") || "/";
  return PATHS.some(pattern => {
    if (pattern.includes(":")) {
      const base = pattern.slice(0, pattern.indexOf("/:"));
      return path === base || path.startsWith(`${base}/`);
    }
    return path === pattern || path.startsWith(`${pattern}/`);
  });
}
